import { pushToDataLayer } from '../datalayer';

export function trackUseCoupon({
  coupon,
  wasValid,
  location,
  step,
  amountDiscounted,
}: {
  coupon: string;
  wasValid: boolean;
  location: string;
  step?: string;
  amountDiscounted: number;
}) {
  let step_number: number | undefined = undefined;
  let step_label = step;
  if (step) {
    if (step === 'contact_information') step_number = 2;
    else step_number = 3;
  }
  if (location === 'cart') {
    step_number = 1;
    step_label = 'my-cart';
  }
  pushToDataLayer({
    event: wasValid ? 'use_valid_coupon' : 'use_invalid_coupon',
    coupon,
    location,
    step_label,
    step_number,
    value: amountDiscounted,
  });
}
